export default "__VITE_ASSET__BYpaS1gV__"